interface HeaderProps {
  onOpenPopup: () => void;
}

export default function Header({ onOpenPopup }: HeaderProps) {
  return (
    <header className="relative min-h-screen flex items-center justify-center overflow-hidden bg-zinc-950">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/bf4c5aaf069dc0b99675024bb2624aa0.jpg"
          alt="College Campus Event"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
        <div className="absolute inset-0 bg-gradient-to-br from-red-600/20 via-transparent to-purple-600/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-600/20 border border-red-600/30 rounded-full mb-8">
          <div className="w-2 h-2 bg-red-600 rounded-full animate-pulse"></div>
          <span className="text-red-500 text-sm font-semibold tracking-wide uppercase">
            College Mentalist Show
          </span>
        </div>

        {/* Main Heading */}
        <h1 className="text-6xl lg:text-8xl font-black text-white mb-6 tracking-tight leading-none">
          UNLOCK YOUR
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 via-red-600 to-purple-600">
            MIND
          </span>
        </h1>

        {/* Sub-headline */}
        <p className="text-2xl lg:text-3xl font-bold text-white mb-6 leading-tight">
          The Ultimate Interactive Experience for Your Campus.
        </p>

        {/* Description */}
        <p className="text-lg text-zinc-300 max-w-3xl mx-auto mb-12 leading-relaxed">
          A fast-paced, high-energy mentalism show created specifically for student life, orientation, and campus festivals.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={onOpenPopup}
            className="px-8 py-4 bg-red-600 text-white text-base font-bold rounded-full hover:bg-red-700 transition-all hover:scale-105 shadow-lg shadow-red-600/30 whitespace-nowrap"
          >
            Bring Thomas to Your Campus
          </button>
          <button
            onClick={onOpenPopup}
            className="px-8 py-4 bg-transparent border-2 border-white text-white text-base font-bold rounded-full hover:bg-white hover:text-zinc-900 transition-all whitespace-nowrap"
          >
            Check Available Dates
          </button>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-red-600/20 rounded-full blur-3xl"></div>
      <div className="absolute top-0 right-0 w-96 h-96 bg-purple-600/20 rounded-full blur-3xl"></div>
    </header>
  );
}